import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { RecoilRoot } from "recoil";
import { GET_CASE_DETAILS } from "./queries";
import { client } from "../../../index";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";
import PopupMenu from "../../SimpleForm/PopupMenu";
import {
  CaseDetailISchemaResolver,
  caseDetailFormActionResolver,
} from "./CaseDetailResolver";
import SimpleForm from "../../SimpleForm";
import { FaFilePdf, FaSpinner, FaTimes } from "react-icons/fa";
import { fetchLinkingCaseData } from "../../SimpleForm/CaseReuse/helpers";
import inputResolver from "../../SimpleForm/FieldResolver";
import Util from "../../../global/utils/Helpers";
import momentTimezone from "moment-timezone";
import _ from "underscore";
import "./caseDetails.scss";
import CaseDocumentsTable from "./CaseDetailsTables/CaseDocumentsTable";
import HousingInspectionTable from "./CaseDetailsTables/HousingInspectionTable";
import ui_utils from "../../SimpleForm/UI/uiUtils";
import {
  applicationTypeResolver,
  getCaseOwnerName,
  getExpirationDate,
} from "./CaseDetailUtils";
import CaseRecordsTable from "./CaseDetailsTables/CaseRecordsTable";

const CaseDetail = (props) => {

  const [selectedCase, setSelectedCase] = useState({});
  const [isLinked, setIsLinked] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalSuccessIsOpen, setModalSuccessIsOpen] = useState(false);
  const [activeForm, setActiveForm] = useState(undefined);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [caseActionDone, setCaseActionDone] = useState([]);
  const [selectedCaseHousing, setHousingSubset] = useState({});
  const [formVersionId, setVersionId] = useState(1);
  const [linkedPWD, setLinkedPWD] = useState(null);
  const [errors, setErrors] = useState(null);
  const [extraData, setExtraData] = useState({});
  const [caseActionRecords, setCaseActionRecords] = useState([]);

  const { form_id, application_id } = props;

  const isHistorical = props?.location?.state?.isHistorical;
  const isAppeal = props?.location?.state?.isAppeal;
  const isAssignedCaseNumber = props.location?.state?.isAssignedCaseNumber;

  const user = useSelector((state) => state.appReducer.userDataReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      !linkedPWD &&
      !errors &&
      !!selectedCase.jobOppPwdNumber &&
      form_id == "9089"
    ) {
      fetchLinkingCaseData(selectedCase.jobOppPwdNumber, form_id).then(
        (data) => {
          if (!!data?.data?.getDatahubCase) {
            setLinkedPWD(data.data.getDatahubCase);
            setErrors(null);
          } else {
            setLinkedPWD(null);
            setErrors(data.errors);
          }
        }
      );
    }
  }, [
    errors,
    fetchLinkingCaseData,
    linkedPWD,
    selectedCase,
    setErrors,
    setLinkedPWD,
  ]);

  const [caseDetailTab, setCaseDetailActive] = useState("Case Documents");

  const caseTabArr = [
    {
      type: "Case Documents",
      shouldDisplay: () => true,
    },
    {
      type: "Housing Inspection Results",
      shouldDisplay: () =>
        selectedCase.formId === "790A" &&
        (formVersionId === 2 || formVersionId === 3),
    },
    {
      type: "External Case Actions",
      shouldDisplay: () => selectedCase.formId === "9089",
    },
  ];

  const showStartEndDate = form_id !== "9089";

  const handleClick = (title) => {
    openModal(title);
  };

  const filterHousingResults = (data, setVersionId, setHousingSubset) => {
    let obj = {};
    if (data) {
      data = JSON.parse(JSON.stringify(data));

      // initial filtering for only things that need to be used for housing
      for (let item in data) {
        if (
          (item.includes("housingComp") || item.includes("isCompliance")) &&
          typeof data[item] === "number" &&
          data[item] === 1
        ) {
          if (!obj["housingStandards"]) obj["housingStandards"] = [item];
          else obj["housingStandards"].push(item);
        } else if (
          item.includes("housing") ||
          item.includes("inspectionStatus") ||
          item.includes("hasActiveInspNotification") ||
          item.includes("inspectionIndividualId")
        ) {
          obj[item] = data[item];
        }
      }

      if (data?.formVersionId && typeof data?.formVersionId === "number") {
        setVersionId(data.formVersionId);
      }
      obj.docs = data.docs;
      setHousingSubset(obj);
    }
  };

  const handleClickDebounced = _.debounce(handleClick, 4000, true);
  useQuery(
    GET_CASE_DETAILS,
    {
      variables: {
        caseNumber: application_id,
        formId: form_id,
      },
      onCompleted: async ({
        getCaseDetails: {
          caseDetails,
          caseActionHistory,
          isPostDeterminationAvailable,
        },
      }) => {
        const { formId, applicationId } = caseDetails;
        const { case_action_done = [], case_action_records = [] } =
          caseActionHistory;
        const records = case_action_records ?? [];
        const actionsDone = case_action_done ?? [];
        if (formId === "790A") {
          isLinkedCheck(applicationId, caseDetails, isPostDeterminationAvailable);
          filterHousingResults(caseDetails, setVersionId, setHousingSubset);
        } else {
          setExtraData({
            ...extraData,
            extensionRequestDate: getExpirationDate(
              form_id,
              caseDetails,
              records
            ),
          });

          setSelectedCase({
            ...selectedCase,
            ...caseDetails,
            is_postdetermination_available: isPostDeterminationAvailable,
          });
          setIsLinked(false);
        }

        setCaseActionDone(actionsDone);
        setCaseActionRecords(records);
      },
    },
    client
  );

  const getpdf = async (case_number) => {
    let apiIndex = Util.isLocalhost()
      ? `http://localhost:9393/auth/document/dh/case-document/${case_number}`
      : `${Util.getCurrentHost()}/auth/auth/document/dh/case-document/${case_number}`;

    await fetch(apiIndex, {
      credentials: "include",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Basic " +
          window.btoa("flagdevteam1:account-standard-xxxxx44xx3xxxxxxxxxxxx1"),
      },
    })
      .then((r) => {
        if (!r.ok) {
          setPdfLoading(false);
          throw Error();
        }
        return r.blob();
      })
      .then((blob) => {
        setPdfLoading(false);
        if (blob.size > 0) {
          // saveAs(blob, fileName);
          window.open(URL.createObjectURL(blob));
        } else {
          throw Error();
        }
      })
      .catch(function (e) {
        const OFLC_GET_PDF_FAILURE = "OFLC_GET_PDF_FAILURE";
        function oflcFaildPdfFetch() {
          return {
            type: OFLC_GET_PDF_FAILURE,
            payload: {
              status: "info",
              message: "No PDF available for this case yet. Check back later.",
            },
          };
        }
        dispatch(oflcFaildPdfFetch());
      });
  };

  const isLinkedCheck = async (application_id, x, isPostDeterminationAvailable) => {
    let query = `query {
			isLinked790(
				case_number: "${application_id}"
				) 
			}`;
    let result = await Util.handleGraphql(query);
    setIsLinked(result.data.isLinked790);
    setSelectedCase({ ...selectedCase, ...x, is_postdetermination_available: isPostDeterminationAvailable });
  };

  const openModal = (item) => {
    setModalIsOpen(true);
    setActiveForm(item);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const closeSuccessModal = () => {
    setModalSuccessIsOpen(false);
  };

  const saveEntity = async (values, activeForm) => {
    let note, description, fileType, caseNote, withdrawal_reason;
    let files = values.files || "";
    activeForm = activeForm.replace(/_.*/gm, "");
    let form_id = selectedCase.formId;
    let action = `${form_id} ${activeForm}`;
    // To support 9089's extensive extension request tracking
    if (form_id === "9089" && activeForm === "Request Extension") {
      action = `${form_id} ${selectedCase.externalStatus} ${activeForm}`;
    }
    caseNote = values.case_note === "- Select -" ? "" : values.case_note;
    note = caseNote || "";
    description = values.document_description || "";
    fileType = values.fileType || "";
    description = description ? Util.cleanGraphqlParamater(description) : "";
    note = note ? Util.cleanGraphqlParamater(note) : "";
    //Withdrawal reason for PERM's withdrawal only
    withdrawal_reason = values?.withdrawal_reason
      ? Util.cleanGraphqlParamater(values?.withdrawal_reason)
      : "";

    let test = undefined;
    let files_QL = [];

    if (form_id === "9142B" && activeForm === "Post-Certification") {
      fileType = description;
    }

    if (files) {
      files.forEach((f) => {
        let obj = {
          document_name: f.document_name,
          description: description,
          size: f.size,
          displayName: f.displayName,
          lastModified: f.lastModified,
          state: f.state,
          percentage: f.percentage,
          fileType: fileType ? fileType : "",
          document_path: f.document_path,
        };
        let file_ql = "{" + Util.parseObjectForGraphql(obj) + "}";
        files_QL.push(file_ql);
      });
      test = `submitCaseDetail(application_id:"${selectedCase.applicationId}",
			form_id: "${form_id}"
			file: [${files_QL}]
			action: "${activeForm}"
      externalStatus: "${selectedCase.externalStatus}"
			CaseDetailInput:{case_number:"${selectedCase.caseNumber}", action: "${action}", note:"${note}"`;
    } else {
      test = `submitCaseDetail(application_id:"${selectedCase.applicationId}"
			action: "${activeForm}"
			form_id: "${form_id}"
      externalStatus: "${selectedCase.externalStatus}"
			CaseDetailInput:{case_number:"${selectedCase.caseNumber}", action: "${action}", note:"${note}", withdrawal_reason:"${withdrawal_reason}"`;
    }

    const query = `query {
			${test}})
		}`;
    const result = await Util.handleGraphql(query);
    if (result && result.data && result.data.submitCaseDetail) {
      const parsed_submit_case_detail = JSON.parse(
        result.data.submitCaseDetail
      );

      const updated_case_actions_done =
        parsed_submit_case_detail?.message?.updated_case_actions;
      const records = parsed_submit_case_detail?.message?.case_action_records;

      if (
        updated_case_actions_done &&
        Array.isArray(updated_case_actions_done)
      ) {
        setCaseActionDone(updated_case_actions_done);
      }

      if (!!records) {
        setCaseActionRecords(records);
      }

      if (
        parsed_submit_case_detail?.message?.conditionally_updated_case_actions
      ) {
        const { case_action_done = [] } =
          parsed_submit_case_detail?.message
            ?.conditionally_updated_case_actions ?? {};

        const updatedCaseActionsDone = case_action_done ?? [];

        setExtraData({
          ...extraData,
          extensionRequestDate: getExpirationDate(
            form_id,
            selectedCase,
            caseActionRecords
          ),
        });

        setCaseActionDone(updatedCaseActionsDone);
      }
    }

    if (result.data) {
      const OFLC_CASE_ACTION_SUBMISSION_SUCCESS =
        "OFLC_CASE_ACTION_SUBMISSION_SUCCESS";
      function oflcCaseActionSubmissionSuccessFetch() {
        return {
          type: OFLC_CASE_ACTION_SUBMISSION_SUCCESS,
          payload: {
            status: "success",
            message: "Your form was submitted successfully.",
          },
        };
      }
      dispatch(oflcCaseActionSubmissionSuccessFetch());
      setModalSuccessIsOpen(true);
    } else {
      const message = Util.isUserErrorMessage(result)
        ? result.errors?.[0]?.message
        : "Sorry, your form was unable to submit. Please try again later.";
      const OFLC_CASE_ACTION_SUBMISSION_FAILURE =
        "OFLC_CASE_ACTION_SUBMISSION_FAILURE";
      function oflcCaseActionSubmissionFailFetch() {
        return {
          type: OFLC_CASE_ACTION_SUBMISSION_FAILURE,
          payload: {
            status: "error",
            message,
          },
        };
      }
      dispatch(oflcCaseActionSubmissionFailFetch());
    }

    closeModal();
  };

  const closeButton = {
    position: "absolute",
    right: "20px",
    top: "20px",
    border: "none",
    background: "none",
    padding: 0,
  };

  const closeButtonIcon = {
    height: "40px",
    width: "40px",
  };

  const contentStyle = {
    boxShadow: "inset 0px 4px 0px 0px #AEB0B5, 0 2px 6px 0 rgba(0,0,0,0.5)",
    padding: "0",
    paddingTop: "4px",
    border: "none",
  };
  const arrowStyle = {
    width: "0",
    height: "0",
    borderStyle: "solid",
    borderWidth: "0 0 13px 13px",
    outline: "none",
    borderColor: "transparent transparent #AEB0B5 transparent",
    background: "transparent",
    boxShadow: "none",
  };
  const formStyles = {
    padding: " 0 25px",
  };

  const case_number = selectedCase ? selectedCase.caseNumber : null;
  const uiSchemas = CaseDetailISchemaResolver(
    activeForm,
    selectedCase?.caseNumber,
    selectedCase?.caseStatus, //Internal status
    selectedCase.formId
  );
  const actions =
    selectedCase && Object.keys(selectedCase).length > 0
      ? caseDetailFormActionResolver(
          selectedCase?.formVersionId,
          selectedCase.formId,
          selectedCase.externalStatus,
          selectedCase.visaType,
          isLinked,
          selectedCase.is_postdetermination_available
        )
      : null;
  return (
    <div className="profiles-details-container">
      <div className="header-container">
        <div className="header-content">
          {props?.location?.state?.prevPageTitle &&
          props.location.state.prevPageUrl ? (
            <Link
              to={`${props.location.state.prevPageUrl}`}
              className="link-back"
            >
              Back to {props.location.state.prevPageTitle}
            </Link>
          ) : (
            <Link to="/dashboard/cases" className="link-back">
              Back to Cases
            </Link>
          )}

          <hr />
          <div className="grid-row">
            <div className="grid-col-5">
              <p>
                Case Number:{" "}
                <span className="case-values">
                  {selectedCase ? selectedCase.caseNumber : "--"}
                </span>
              </p>
              <p>
                Employer Name:{" "}
                <span className="case-values">
                  {selectedCase ? selectedCase.empBusinessName : "--"}
                </span>
              </p>
              <p>
                Job Title:{" "}
                <span className="case-values">
                  {selectedCase ? selectedCase.jobTitle : "--"}
                </span>
              </p>
              {form_id === "9089" && (
                <p>
                  Primary Worksite:{" "}
                  <span className="case-values">
                    {selectedCase?.primaryWorksiteCity &&
                    selectedCase?.primaryWorksiteState
                      ? `${selectedCase.primaryWorksiteCity}, ${selectedCase.primaryWorksiteState}`
                      : "--"}
                  </span>
                </p>
              )}
              <p>
                Submitted Date:{" "}
                <span className="case-values">
                  {selectedCase && selectedCase.dateSubmitted
                    ? momentTimezone(selectedCase.dateSubmitted)
                        .tz("America/New_York")
                        .format("MMMM D, YYYY") +
                      " at " +
                      momentTimezone(selectedCase.dateSubmitted)
                        .tz("America/New_York")
                        .format("h:mm A")
                    : "--"}
                </span>
              </p>
              <p>
                Case Status:{" "}
                <span className="case-values case-status">
                  {selectedCase ? selectedCase.externalStatus : "--"}
                </span>
              </p>
            </div>
            <div className="grid-col-5">
              {form_id === "9089" && (
                <p>
                  Foreign Worker Name:{" "}
                  <span className="case-values">
                    {selectedCase
                      ? ui_utils.capitalizeAllFirstChars(
                          selectedCase.foreign_worker_name
                        )
                      : "--"}
                  </span>
                </p>
              )}
              <p>
                Application Type:{" "}
                <span className="case-values">
                  {selectedCase ? applicationTypeResolver(selectedCase) : "--"}
                </span>
              </p>
              <p>
                Case Owner:{" "}
                <span className="case-values">
                  {selectedCase && selectedCase.userId
                    ? getCaseOwnerName(props, selectedCase.userId)
                    : "--"}
                </span>
              </p>
              {form_id === "9089" &&
                (isHistorical || isAssignedCaseNumber || isAppeal) &&
                !!selectedCase.caseMetadata?.determinationDate && (
                  <p>
                    Determination Date:{" "}
                    <span className="case-values">
                      {selectedCase &&
                      selectedCase.caseMetadata?.determinationDate
                        ? momentTimezone(
                            selectedCase.caseMetadata?.determinationDate
                          )
                            .tz("America/New_York")
                            .format("MMMM D, YYYY")
                        : "--"}
                    </span>
                  </p>
                )}
              {showStartEndDate && (
                <>
                  <p>
                    Start Date:{" "}
                    <span className="case-values">
                      {selectedCase && selectedCase.jobBeginDate
                        ? momentTimezone(selectedCase.jobBeginDate)
                            .utc()
                            .format("MMMM D, YYYY")
                        : "--"}
                    </span>
                  </p>
                  <p>
                    End Date:{" "}
                    <span className="case-values">
                      {selectedCase && selectedCase.jobEndDate
                        ? momentTimezone(selectedCase.jobEndDate)
                            .utc()
                            .format("MMMM D, YYYY")
                        : "--"}
                    </span>
                  </p>
                </>
              )}
              {form_id === "9089" &&
                (isAppeal || isHistorical || isAssignedCaseNumber) && (
                  <>
                    {!!selectedCase?.appealsReceiptDate && (
                      <p>
                        Appeals Receipt Date:{" "}
                        <span className="case-values">
                          {selectedCase && selectedCase?.appealsReceiptDate
                            ? momentTimezone(selectedCase?.appealsReceiptDate)
                                .utc()
                                .format("MMMM D, YYYY")
                            : "--"}
                        </span>
                      </p>
                    )}
                    {!!selectedCase?.noadIssuedDate && (
                      <p>
                        NORD Issued Date:{" "}
                        <span className="case-values">
                          {selectedCase && selectedCase?.noadIssuedDate
                            ? momentTimezone(selectedCase?.noadIssuedDate)
                                .utc()
                                .format("MMMM D, YYYY")
                            : "--"}
                        </span>
                      </p>
                    )}
                    {!!selectedCase?.balcaTransmittalDate && (
                      <p>
                        BALCA Transmittal Date:{" "}
                        <span className="case-values">
                          {selectedCase && selectedCase?.balcaTransmittalDate
                            ? momentTimezone(selectedCase?.balcaTransmittalDate)
                                .utc()
                                .format("MMMM D, YYYY")
                            : "--"}
                        </span>
                      </p>
                    )}
                    {!!selectedCase?.balcaDecisionIssuedDate && (
                      <p>
                        BALCA Decision Date:{" "}
                        <span className="case-values">
                          {selectedCase && selectedCase?.balcaDecisionIssuedDate
                            ? momentTimezone(
                                selectedCase?.balcaDecisionIssuedDate
                              )
                                .utc()
                                .format("MMMM D, YYYY")
                            : "--"}
                        </span>
                      </p>
                    )}
                    {!!selectedCase?.determinationExpDate && (
                      <p>
                        Expiration Date:{" "}
                        <span className="case-values">
                          {selectedCase && selectedCase?.determinationExpDate
                            ? momentTimezone(selectedCase?.determinationExpDate)
                                .utc()
                                .format("MMMM D, YYYY")
                            : "--"}
                        </span>
                      </p>
                    )}
                  </>
                )}
              {selectedCase?.formId && selectedCase.formId === "9142B" && (
                <p>
                  Randomization Information:{" "}
                  <span className="case-values">
                    {selectedCase &&
                    selectedCase.caseMetadata?.randomizationInfo
                      ? selectedCase.caseMetadata.randomizationInfo
                      : "--"}
                  </span>
                </p>
              )}
            </div>
            <div className="grid-col-2 modal-and-pdf-container">
              <PopupMenu
                trigger={
                  <button
                    className="usa-button cases-details-button actionButton"
                    disabled={actions && actions.length > 0 ? false : true}
                  >
                    <span className="cases-details-button-text">Actions</span>
                  </button>
                }
                position="bottom right"
                closeOnDocumentClick
                contentStyle={contentStyle}
                arrowStyle={arrowStyle}
              >
                {actions
                  ? actions.map((item) => {
                      let title = "";
                      let disabled = false;
                      let clean_title;

                      if (typeof item === "string") {
                        title = item;
                      } else {
                        title = item.name;
                        disabled = item.disabled;
                      }
                      clean_title =
                        item?.altLabel || title.replace(/_.*/gm, "");

                      if (
                        caseActionDone?.includes(clean_title) ||
                        (clean_title === "Continue to BALCA" &&
                          caseActionDone.includes("Request for Review") &&
                          (selectedCase.externalStatus === "NOAD ISSUED" ||
                            selectedCase.externalStatus === "NORD ISSUED") &&
                          caseActionRecords?.[caseActionRecords?.length - 1]
                            ?.action === "Request for Review") ||
                        caseActionDone.includes("Withdraw")
                      ) {
                        disabled = true;
                      }
                      return (
                        <div key={title}>
                          <div className="menu">
                            <button
                              className="menu-item menu-item-button dropdown-label-View"
                              style={{
                                color: !disabled ? "#0071BB" : "#a2a2a2",
                              }}
                              type="button" // This removes default submit
                              onClick={(e) => {
                                if (!disabled) {
                                  handleClickDebounced(title);
                                } else {
                                  e.preventDefault();
                                }
                              }}
                            >
                              {clean_title}
                            </button>
                          </div>
                          <hr />
                        </div>
                      );
                    })
                  : null}
              </PopupMenu>
              <button
                className="pdf-link"
                tabIndex={0}
                type="button" // Removes default submit
                onClick={async () => {
                  setPdfLoading(true);
                  await getpdf(case_number);
                }}
              >
                View PDF{" "}
                {pdfLoading ? (
                  <span className="pdf-icon">
                    <FaSpinner className="icon-spin" />
                  </span>
                ) : (
                  <span className="pdf-icon">
                    <FaFilePdf color={"#0473bc"} />
                  </span>
                )}
              </button>
              {form_id === "9089" && extraData?.extensionRequestDate ? (
                <div className="case-details-custom-message">
                  <span
                    style={{
                      fontSize: "15px",
                      color: "red",
                    }}
                  >
                    An extension request was submitted on{" "}
                    {
                      //Requires different formatting: Appian-DH conversions
                      momentTimezone(extraData.extensionRequestDate)
                        .tz("America/New_York")
                        .format("MM/DD/YYYY")
                    }
                  </span>
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <Modal
          isOpen={modalSuccessIsOpen}
          onRequestClose={closeSuccessModal}
          overlayClassName="Overlay"
          className="cases-details-modal cases-details-success-modal Form-Modal"
        >
          <button
            className="modal-empty-button modal-close"
            onClick={closeSuccessModal}
          >
            <FaTimes size={"2em"} />
            <span className="usa-sr-only">Close modal</span>
          </button>
          <h3>Case Action Successfully Submitted</h3>
          <p>
            Your {activeForm && activeForm.replace(/_.*/gm, "")} case action was
            successfully submitted to OFLC. Please note it may take a few
            minutes for the status of this case to update in your dashboard.
          </p>
          <form>
            <button
              className="usa-button usa-button-primary"
              style={{ marginLeft: "auto", width: "auto" }}
              onClick={closeSuccessModal}
            >
              Close
            </button>
          </form>
        </Modal>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          overlayClassName="Overlay"
          className="cases-details-modal"
        >
          <button style={closeButton} onClick={closeModal} type="button">
            <MdClose style={closeButtonIcon} />
          </button>

          <RecoilRoot>
            <SimpleForm
              uiSchema={uiSchemas}
              inputResolver={inputResolver}
              closeModal={closeModal}
              handleSave={(values) => saveEntity(values, activeForm)}
              formStyles={formStyles}
              appId={selectedCase ? selectedCase.caseNumber : ""}
            />
          </RecoilRoot>
        </Modal>
      </div>
      <div className="content-container">
        <div className="grid-row">
          <div
            className="navigation tablet:grid-col-12"
            style={{ paddingBottom: "15px" }}
          >
            {caseTabArr.map(({ type, shouldDisplay }, index) => {
              return (
                <a
                  role="tab"
                  aria-controls={"case_type_" + type + index}
                  tabIndex={index + 1}
                  key={type + index}
                  //new tab is only shown on formVersionId 2 790A
                  style={{
                    display: shouldDisplay() ? "" : "none",
                  }}
                  onClick={() => {
                    setCaseDetailActive(type);
                  }}
                  className={
                    type === caseDetailTab ? "nav-item active" : "nav-item"
                  }
                >
                  {type}
                </a>
              );
            })}
          </div>
        </div>
        <div
          className="grid-row"
          style={{ display: caseDetailTab === "Case Documents" ? "" : "none" }}
        >
          {selectedCase?.docs && (
            <CaseDocumentsTable docs={selectedCase?.docs} />
          )}
        </div>
        <div
          className="grid-row"
          style={{
            display: caseDetailTab === "External Case Actions" ? "" : "none",
          }}
        >
          {!!caseActionRecords && (
            <CaseRecordsTable records={caseActionRecords} />
          )}
        </div>
        <div
          className="grid-row"
          style={{
            display:
              caseDetailTab === "Housing Inspection Results" ? "" : "none",
          }}
        >
          {selectedCase?.docs && (
            <HousingInspectionTable housing={selectedCaseHousing} />
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(CaseDetail);
